export const getTempTotal = (items) => {
  let tempTotal = 0;
  for (let i = 0; i < items.length; i++) {
    tempTotal += Number(items[i].amount)
  }
  return tempTotal

}
